import callInvoicesApi, { callHistoryDetailsApi } from '../call-api/invoices'
import { dateFormatter, cnpjFormatter } from '../../functions'

export function onClassChange(classAttrValue) {
  const classList = classAttrValue.split(" ")
  const cssAttributeToChange = document.querySelectorAll(".class-observer")

  if (classList.includes("sidebar-show"))
    applyStyle(cssAttributeToChange, 100)
  else if (window.matchMedia("(min-width: 768px)").matches)
    applyStyle(cssAttributeToChange, 50)
}

export function applyStyle(attribute, percentage) {
  attribute.forEach(element => {
    element.style.maxWidth = `${ percentage }%`
    element.style.flex = `0 0 ${ percentage }%`
  })
}

export function changeCssAtt(observer, $nextTick) {
  observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      const newValue = m.target.getAttribute(m.attributeName)

      $nextTick(_ => onClassChange(newValue, m.oldValue))
    }
  })

  observer.observe(
    document.querySelector("body"), {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["class"],
    }
  )
}

export async function tryToCallInvoicesApi(cnpj) {
  const apiResponse = await callInvoicesApi({ cnpj: cnpj })

  if (apiResponse) {
    const currentInvoice = apiResponse.data.faturaAtual
    const previousInvoice = apiResponse.data.ultimaFatura
    const invoiceDetails = buildInvoiceDetailsResponse(apiResponse.data.detalhesFaturaAtual)
    const histInvoice = new Array()

    buildHistResponse(apiResponse.data.faturasUltimosMeses, histInvoice)

    return {
      previousDateInvoice: defaultDate(previousInvoice),
      previousValueInvoice: defaultValue(previousInvoice),
      currentDateInvoice: defaultDate(currentInvoice),
      currentValueInvoice: defaultValue(currentInvoice),
      histInvoice: histInvoice,

      taxQtSales: invoiceDetails.taxQtSales,
      taxValueSales: defaultDetailValue(invoiceDetails.taxValueSales),
      taxValue: defaultDetailValue(invoiceDetails.taxValue),

      userActive: invoiceDetails.userActive,
      userPerFranchise: invoiceDetails.userPerFranchise,
      userValuePerFranchise: defaultDetailValue(invoiceDetails.userValuePerFranchise),
      userQtFranchiseInvoiced: invoiceDetails.userQtFranchiseInvoiced,
      userTotalValueFranchise: defaultDetailValue(invoiceDetails.userTotalValueFranchise),

      cancelAllowed: invoiceDetails.cancelAllowed,
      cancelQtTotal: invoiceDetails.cancelQtTotal,
      cancelTotalValue: defaultDetailValue(invoiceDetails.cancelTotalValue),
      cancelOutLimit: invoiceDetails.cancelOutLimit,
      cancelOutLimitValue: defaultDetailValue(invoiceDetails.cancelOutLimitValue),
      cancelTaxOutLimitValue: defaultDetailValue(invoiceDetails.cancelTaxOutLimitValue),

      creditQtSales: invoiceDetails.creditQtSales,
      creditValueSales: defaultDetailValue(invoiceDetails.creditValueSales),
      creditValue: defaultDetailValue(invoiceDetails.creditValue)
    }
  } else {
    return {
      previousDateInvoice: 'Sem movimentação',
      previousValueInvoice: '',
      currentDateInvoice: 'Sem movimentação',
      currentValueInvoice: '',
      invoiceDetails: [],
      histInvoice: []
    }
  }
}

function buildInvoiceDetailsResponse(apiInvoices) {
  const details = apiInvoices
    .map(apiInvoiceInfo => buildInvoiceDetails(apiInvoiceInfo.descItem, JSON.parse(apiInvoiceInfo.detalhes)))
    .reduce((current, next) => Object.assign({ ...current, ...next }), new Object())

  return details
}

function buildInvoiceDetails(typeItem, apiDetails) {
  if (typeItem == 'Taxa Vendas')
    return {
      taxQtSales: apiDetails.quantidadeVendas,
      taxValueSales: apiDetails.valorVendas,
      taxValue: apiDetails.valorTaxa
    }
  else if (typeItem == 'Usuários Ativos')
    return {
      userActive: apiDetails.usuariosAtivos,
      userPerFranchise: apiDetails.usuariosPorFranquia,
      userValuePerFranchise: apiDetails.valorPorFranquia,
      userQtFranchiseInvoiced: apiDetails.qtdFranquiasFaturadas,
      userTotalValueFranchise: apiDetails.valorTotalFranquias
    }
  else if (typeItem == 'Cancelamentos fora do limite')
    return {
      cancelAllowed: apiDetails.cancelamentosPermitidos,
      cancelQtTotal: apiDetails.qtdTotalCancelamentos,
      cancelTotalValue: apiDetails.valorTotalCancelamentos,
      cancelOutLimit: apiDetails.cancelamentosForaLimite,
      cancelOutLimitValue: apiDetails.valorVendasCanceladasForaLimite,
      cancelTaxOutLimitValue: apiDetails.valorTaxaVendasCanceladasForaLimite
    }
  else
    return {
      creditQtSales: apiDetails.quantidadeVendas,
      creditValueSales: apiDetails.valorVendas,
      creditValue: apiDetails.valorTaxa
    }
}

function buildHistResponse(apiInvoices, invoices) {
  return apiInvoices.map(apiHistInvoice => {
    return invoices.push({
      date: apiHistInvoice.dataVencimento ? dateFormatter(apiHistInvoice.dataVencimento) : `Não definida`,
      number: apiHistInvoice.id,
      totalValue: `R$ ${ Number(apiHistInvoice.valorTotal).toFixed(2) }`,
      isPaid: getIcon(apiHistInvoice.pago),
      isClosed: getIcon(apiHistInvoice.fechada)
    })
  })
}

function defaultDate(field) {
  return Object.entries(field) == 0 ? 'Sem movimentação' : `Vencimento ${ dateFormatter(field.dataVencimento) }`
}

function defaultValue(field) {
  return Object.entries(field) == 0 ? '' : `R$ ${ Number(field.valorTotal).toFixed(2) }`
}

function defaultDetailValue(field) {
  return field ? `${ Number(field).toFixed(2) }` : `0.00`
}

function getIcon(field) {
  return field ? 'fa fa-check' : 'fa fa-times'
}

export async function seeHistoryDetails(item) {
  const cnpj = cnpjFormatter(localStorage.getItem("cnpj"))
  const invoiceId = item.number
  const histApiResponse = await callHistoryDetailsApi(invoiceId, cnpj)

  const details = buildInvoiceDetailsResponse(histApiResponse.data)

  this.$parent.taxQtSales = details.taxQtSales
  this.$parent.taxValueSales = defaultDetailValue(details.taxValueSales)
  this.$parent.taxValue = defaultDetailValue(details.taxValue)

  this.$parent.userActive = details.userActive
  this.$parent.userPerFranchise = details.userPerFranchise
  this.$parent.userValuePerFranchise = defaultDetailValue(details.userValuePerFranchise)
  this.$parent.userQtFranchiseInvoiced = details.userQtFranchiseInvoiced
  this.$parent.userTotalValueFranchise = defaultDetailValue(details.userTotalValueFranchise)

  this.$parent.cancelAllowed = details.cancelAllowed
  this.$parent.cancelQtTotal = details.cancelQtTotal
  this.$parent.cancelTotalValue = defaultDetailValue(details.cancelTotalValue)
  this.$parent.cancelOutLimit = details.cancelOutLimit
  this.$parent.cancelOutLimitValue = defaultDetailValue(details.cancelOutLimitValue)
  this.$parent.cancelTaxOutLimitValue = defaultDetailValue(details.cancelTaxOutLimitValue)

  this.$parent.creditQtSales = details.creditQtSales
  this.$parent.creditValueSales = defaultDetailValue(details.creditValueSales)
  this.$parent.creditValue = defaultDetailValue(details.creditValue)

  return this
}